// extracted by mini-css-extract-plugin
export default {"root":"EmptyState_root__7dc-S"};